import axios from "../configRequest";
import { I_AXIOS } from "../configRequest.model";

interface Payload {
    token: string;
    deviceId: string;
    paymentToken: string;
    amount: string;
}

interface Data {
    url: string;
    error: string;
    internal: {
        status: string;
        redirecturl: string;
        orderID: string;
        remoteID: string;
        confirmation: string;
        reason: string;
        hash: string;
        error: boolean;
        success: boolean;
    };
}

async function apiAutopay(payload: Payload) {
    const fetchData = await axios.post<Data>(
        `${I_AXIOS.STAGE_API_HOST}/api/tin/v1/site/quest/autopay?token=${payload.token}&deviceId=${payload.deviceId}&paymentToken=${payload.paymentToken}&amount=${payload.amount}`,
    );
    return fetchData.data;
}

export default apiAutopay;
